var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex justify-center align-center position-relative"},[_c('img',{staticClass:"position-absolute bg-shape",attrs:{"src":_vm.imgShape,"alt":""}}),_c('div',{staticClass:"idiom-text"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }